import { useTranslation } from 'react-i18next';
import { Navigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { useAutoExportAccoutingRetrocessionFeePdfViewModel } from './hooks/use-auto-export.viewmodel';
import { useExportAccountingRetrocessionFeeToPdfViewModel } from './hooks/use-export-to-pdf.viewmodel';
import { RetrocessionFeeDocument } from './retrocession-fee-document';
import { useAccoutingRetrocessionFeeViewModel } from './use-retrocession-fee.viewmodel';

export const AccountingRetrocessionFee = ({
  autoExport = false,
  accountingId,
  onExportSuccess,
  onExportFailed,
}: {
  autoExport?: boolean;
  accountingId?: string;
  onExportSuccess?: () => void;
  onExportFailed?: () => void;
}) => {
  const { t } = useTranslation();

  const viewModel = useAccoutingRetrocessionFeeViewModel({ accountingId });

  const exportToPdfViewModel = useExportAccountingRetrocessionFeeToPdfViewModel(
    {
      information: viewModel.information,
    },
  );

  useAutoExportAccoutingRetrocessionFeePdfViewModel({
    autoExport,
    pageLoaded: viewModel.pageLoaded,
    ressourceLoaded: viewModel.logoLoaded,
    exportToPdfViewModel,
    onSuccess: onExportSuccess,
    onFailed: onExportFailed,
  });

  if (!viewModel.pageLoaded || !viewModel.information) {
    return null;
  } else if (viewModel.unauthorized) {
    if (autoExport) {
      onExportFailed?.();
      return null;
    } else {
      return <Navigate to="/" />;
    }
  }

  return (
    <div className="min-h-screen w-full">
      <div className="flex flex-col">
        <header className="flex h-[60px] items-center justify-between border-b bg-muted/40 px-4">
          <h1 className="font-semibold text-3xl">
            {t('accounting-retrocession-fee.title')}
          </h1>
          <div className="flex gap-2">
            <Button
              onClick={exportToPdfViewModel.export}
              loading={exportToPdfViewModel.exporting}
            >
              {t('accounting-retrocession-fee.pdf-template.export-btn')}
            </Button>
          </div>
        </header>

        <RetrocessionFeeDocument
          information={viewModel.information}
          contentRef={exportToPdfViewModel.contentRef}
          onLogoLoad={() => {
            viewModel.setLogoLoaded(true);
          }}
        />
      </div>
    </div>
  );
};
